export const ru = {
    'add-group': 'Добавить группу',
    'combinations-count': {
        one: '{count} фраза будет создана и добавлена в список.',
        some: '{count} фразы будет создано и добавлено в список.',
        many: '{count} фраз будет создано и добавлено в список.',
        none: '{count} фраз будет создано и добавлено в список.'
    }
};
